import React from "react";
import Modal from "../../../../elements/Modal";
import Reminder from "../Reminder";

const ReminderModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={"Send Reminder"}>
      <Reminder getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ReminderModal;
